import NotPaidDeal from './NotPaidDeal.component';

export default NotPaidDeal;
